import {FC, MouseEvent, useContext, useState} from 'react';
import {PhotoProvider} from 'react-photo-view';
import {useRecoilValue} from 'recoil';
import {OverlayRenderProps} from 'react-photo-view/dist/types';

import {CircularProgress, IconButton, Stack} from '@mui/material';
import {DelayImage} from './DelayImage';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';

import {EventBusContext} from '../../../../../providers/EventBus';

import {currentServiceRequestState} from '../../../../../store/service-requests/atoms';

import {IServiceRequest} from '../../../../../shared/types/serviceRequest.types';
import {IDocument} from '../../../../../shared/types/document.types';

interface IPhotoForm {
  docs: IDocument[];
}

const ToolBar: FC<OverlayRenderProps & {photoNames: string[]}> = ({onScale, scale, images, index, photoNames}) => {
  const serviceRequest = useRecoilValue(currentServiceRequestState) as IServiceRequest;
  const [loadingState, setLoadingState] = useState<Record<number, boolean>>({});
  const {bus} = useContext(EventBusContext);

  const onDownLoad = async (e: MouseEvent<HTMLButtonElement>) => {
    try {
      setLoadingState((prev) => ({...prev, [index]: true}));
      e.preventDefault();

      const anchor = document.createElement('a');
      anchor.href = images[index].src as string;
      anchor.download = `Заявка_№${serviceRequest.id}_недопуск_${photoNames[index]}`;
      anchor.style.display = 'none';
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
    } catch (err) {
      bus?.emit('error', [err]);
    } finally {
      setLoadingState((prev) => ({...prev, [index]: false}));
    }
  };

  return (
    <>
      <IconButton disabled={loadingState[index]} onClick={onDownLoad}>
        {loadingState[index] ? (
          <CircularProgress sx={{height: 24, width: 24}} />
        ) : (
          <VerticalAlignBottomIcon htmlColor="#fff" />
        )}
      </IconButton>
      <IconButton onClick={() => onScale(scale + 1)}>
        <ZoomInIcon htmlColor="#fff" />
      </IconButton>
      <IconButton onClick={() => onScale(scale - 1)}>
        <ZoomOutIcon htmlColor="#fff" />
      </IconButton>
    </>
  );
};

export const PhotoForm: FC<IPhotoForm> = ({docs}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <PhotoProvider
        overlayRender={({images, index}) => {
          return (
            <Stack
              sx={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                padding: '.5rem',
                zIndex: 50,
                background: '#00000080',
              }}
            >
              <Stack>{images[index].overlay}</Stack>
            </Stack>
          );
        }}
        toolbarRender={(props) => <ToolBar photoNames={docs.map((item) => item.fileName)} {...props} />}
      >
        {docs.map((doc, index) => (
          <DelayImage key={index} photo={doc} label={index === 0 ? 'Фото уведомления' : 'Фото акта недопуска'} />
        ))}
      </PhotoProvider>
    </Stack>
  );
};
